import { Cpu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BRANDS = {
  radxa: { name: 'Radxa', src: '/radxa-logo.svg' },
  raspberry: { name: 'Raspberry Pi', src: '/raspberry-pi-logo.svg' },
};
const text = (value) => typeof value === 'string' ? value.replace(/\0/g, '').trim() : '';

// Hardware metadata is reported by the controller. User-editable names, notes,
// serial numbers, and a Rockchip CPU do not establish a board manufacturer.
export function deviceHardware(device) {
  const hw = device?.hw_info;
  if (!hw || typeof hw !== 'object' || Array.isArray(hw)) return { brand: null, model: '' };
  const model = text(hw.board_model);
  const manufacturer = text(hw.manufacturer);
  const brandFor = (value) => {
    if (/^(?:radxa\b|rock[\s-]*pi\b)/i.test(value)) return 'radxa';
    if (/^raspberry\s+pi\b/i.test(value)) return 'raspberry';
    return null;
  };
  const modelBrand = brandFor(model);
  const manufacturerBrand = brandFor(manufacturer);
  // Contradictory metadata must not result in a confidently wrong logo.
  const key = modelBrand && manufacturerBrand && modelBrand !== manufacturerBrand
    ? null : manufacturerBrand || modelBrand;
  return { brand: BRANDS[key] || null, model };
}

export default function DeviceLogo({ device, size = 40 }) {
  const { t } = useTranslation();
  const { brand } = deviceHardware(device);
  return (
    <span className={`device-vendor-logo${brand ? ' device-vendor-logo-official' : ''}`} style={{ width: size, height: size }}>
      {brand ? <img src={brand.src} alt={brand.name} width={size} height={size} />
        : <Cpu size={Math.round(size * 0.55)} role="img" aria-label={t('deviceHardware.unknown')} />}
    </span>
  );
}

export function DeviceHardwareLabel({ device }) {
  const { t } = useTranslation();
  const { brand, model } = deviceHardware(device);
  const label = brand && model && !model.toLowerCase().includes(brand.name.toLowerCase())
    ? `${brand.name} · ${model}` : model || brand?.name || t('deviceHardware.unknown');
  return <span className="device-hardware-label">{label}</span>;
}

export function DeviceHardware({ device, size = 40 }) {
  return <span className="device-hardware"><DeviceLogo device={device} size={size} /><DeviceHardwareLabel device={device} /></span>;
}
